// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  language: '',
  url_portal: 'totvshealthplans',
  version: 'v1.0(231114)',

  // Mingle
  app_identifier: '64aead1f95fd1f3a1c74da91',
  environment: 'DEV',
  server: 'https://dev-mingle.totvs.com.br',
  web: true,
  usage_metrics: true,
  gateway: true,
  ocr: false,
  crashr: false,
  push_notification: false
};
